import React from 'react';
import { Link } from 'react-router-dom';
import CelestialLayout from '../components/celestial/CelestialLayout';
import TopNav from '../components/celestial/TopNav';
import MaterialIcon from '../components/celestial/MaterialIcon';

export default function NotFoundPage() {
  return (
    <CelestialLayout>
      <TopNav />
      <main className="celestial-main celestial-section-pad">
        <div className="celestial-container" style={{ maxWidth: '480px' }}>
          <div className="celestial-glass" style={{ padding: '2rem' }}>
            <MaterialIcon name="travel_explore" size={48} />
            <h1 className="celestial-headline-xl" style={{ marginTop: '1rem' }}>
              Sayfa bulunamadı
            </h1>
            <p className="celestial-body-lg">
              Bu adres için henüz bir sayfa yok veya uygulama güncelleniyor. Şifre sıfırlama için
              e-postadaki bağlantıyı tekrar deneyin.
            </p>
            <p style={{ marginTop: '1.5rem' }}>
              <Link to="/" className="celestial-btn-primary">
                Ana sayfa
              </Link>
              {' '}
              <Link to="/giris" className="celestial-btn-secondary">
                Giriş
              </Link>
            </p>
          </div>
        </div>
      </main>
    </CelestialLayout>
  );
}
